<template>
  <v-sheet
    v-if="value.color_scheme && value.color_scheme.background_color"
    :class="`bg-${value.color_scheme.background_color.id}`"
    :theme="value.color_scheme.theme"
    class="pt-8 pb-6"
    tag="section"
  >
    <TextContent :value="value" />
  </v-sheet>

  <section v-else>
    <TextContent :value="value" />
  </section>
</template>

<script setup>
defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
